import Typography from '@cobliteam/ui/components/Typography';
import { cn } from '@cobliteam/ui/utils';
import { motion } from 'motion/react';
import type React from 'react';

interface ProgressBarProps extends React.HTMLProps<HTMLDivElement> {
  progress: number;
  label?: string;
}

const ProgressBar = ({ progress, label, className, ...props }: ProgressBarProps) => {
  const clampedProgress = Math.max(0, Math.min(100, progress));

  return (
    <div className={'flex h-2 items-center gap-2'} {...props}>
      <div className={cn('relative size-full overflow-hidden rounded bg-gray-6', className)} role='progressbar' aria-labelledby='progress-bar-label'>
        <motion.div
          className='absolute top-0 left-0 h-full rounded bg-primary-11'
          initial={{ width: 0 }}
          animate={{ width: `${clampedProgress}%` }}
          transition={{ duration: 0.5 }}
        />
      </div>
      {label && (
        <Typography id='progress-bar-label' as={'p'} className='text-nowrap' color='secondary'>
          {label}
        </Typography>
      )}
    </div>
  );
};

export default ProgressBar;
